<ion-app>
  <ion-split-pane *ngIf="menu.enable_pos_menu" contentId="main" class="posMenu 12339999">
    <ion-menu [ngClass]="(db.side_menu) ?'Menu-pos':'Menu__pos'" contentId="main" side="start" menuId="profileMenu">
      <ion-header class="ion-no-border">
        <ion-toolbar [ngClass]="db.ismobile?'ion-toolbar__mobile':'ion-toolbar'">
          <div *ngIf="db.side_menu" class="logo">
            <img src="assets/logo-new-white.svg" alt="logo">
          </div>
          <div *ngIf="!db.side_menu" class="logo-g">
            <img src="assets/ogo-new-white.svg" alt="logo">
          </div>
        </ion-toolbar>
      </ion-header>
      <!-- (mouseenter)="db.side_menu == false ? (db.side_menu = true && hover_menu = true) : null"   (mouseleave)="hover_menu == true ? (db.side_menu = true && hover_menu = false) : null" -->
      <ion-content [ngClass]="db.ismobile?'bg__mobile':'bg'">
        <div *ngIf="false">
          <ion-list class="side-menu" *ngFor="let page of menu.menu_items_list">
            <!-- *ngIf="!db.ismobile" -->
            <ion-menu-toggle translate auto-hide="false" (click)="page.sub_category? Sub_category() : null">
              <!-- <ion-item lines="full" [routerDirection]="'root'" (click)="openPage(page)" lines="none" [ngClass]="{'active': (menu.active_menu == page.label)}">
                            <ion-icon src="{{page.icon}}"></ion-icon>
                            <div class="title">{{page.label}}</div>
                            </ion-item> -->
              <!-- [ngClass]="{'active': (menu.active_menu == page.label)} -->
              <div (click)="openPage(page)" [class.active]="menu.active_menu == page.label" class="p0 m_header mouse" [class.m__header]="!db.side_menu">
                <!-- [ngClass]="db.side_menu?'p0 m_header mouse':'p0 m__header mouse'" -->
                <ion-icon *ngIf="menu.active_menu != page.label " src="{{page.icon}}"></ion-icon>
                <ion-icon class="Selected__icon" *ngIf="menu.active_menu == page.label" src="{{page.whiteicon}}"></ion-icon>
                <p *ngIf="db.side_menu" class="p0 hover_title title">{{page.label}}</p>
                <ion-icon class="forwd__icon" *ngIf="!db.ismobile && menu.active_menu == page.label && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
                <ion-icon class="forwd__icon" *ngIf="!sub_category && page.sub_category && db.side_menu" src="assets/icon/down-arrow.svg"></ion-icon>
                <ion-icon class="forwd__icon" *ngIf="sub_category && page.sub_category && db.side_menu" src="assets/icon/up-arrow.svg"></ion-icon>
                <!-- {{sub_category}} -->
                <!-- {{page.label == 'Catelog'}} -->
              </div>
            </ion-menu-toggle>
            <ion-list class="m-0  p0" *ngIf="sub_category && db.side_menu && page.sub_category">
              <!-- {{sub_category}} -->
              <ion-menu-toggle class="m_header mouse" *ngFor="let item of page.sub_category" (click)="openPage(item)" [class.active]="menu.active_sub == item.label" [class.m__header]="!db.side_menu">
                <!-- <ion-icon *ngIf="menu.active_menu != page.label " src="{{item.icon}}"></ion-icon> -->
                <!-- <ion-icon class="Selected__icon" *ngIf="menu.active_menu == page.label" src="{{item.whiteicon}}"></ion-icon> -->
                <p *ngIf="db.side_menu" class="p0 pl35 hover_title title">{{item.label}}</p>
                <ion-icon class="forwd__icon" *ngIf="!db.ismobile && menu.active_sub == item.label && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
              </ion-menu-toggle>
            </ion-list>
            <!-- <ion-accordion-group>

                    </ion-accordion-group> -->
          </ion-list>
        </div>
        <ion-list class="side-menu " *ngFor="let page of menu.menu_items_list">
          <ion-menu-toggle *ngIf="page.label != 'Catalog'" translate auto-hide="false">
            <div (click)="openPage(page)" [class.active]="menu.active_menu == page.label" class="p0 m_header mouse" [class.m__header]="!db.side_menu">
              <ion-icon *ngIf="menu.active_menu != page.label " src="{{page.icon}}"></ion-icon>
              <ion-icon class="Selected__icon" *ngIf="menu.active_menu == page.label" src="{{page.whiteicon}}"></ion-icon>
              <p *ngIf="db.side_menu" class="p0 hover_title title mt0">{{page.label}}</p>
              <ion-icon class="forwd__icon" *ngIf="!db.ismobile && menu.active_menu == page.label && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
              <ion-icon class="forwd__icon" *ngIf="!sub_category && page.sub_category" src="assets/icon/down-arrow.svg"></ion-icon>
              <ion-icon class="forwd__icon" *ngIf="sub_category && page.sub_category" src="assets/icon/up-arrow.svg"></ion-icon>
            </div>
          </ion-menu-toggle>
          <div *ngIf="page.label == 'Catalog'" (click)="page.sub_category? Sub_category() : null" [class.active]="menu.active_menu == page.label" class="p0 m_header mouse" [class.m__header]="!db.side_menu">
            <ion-icon *ngIf="menu.active_menu != page.label " src="{{page.icon}}" (click)="db.side_menu = true"></ion-icon>
            <ion-icon class="Selected__icon" *ngIf="menu.active_menu == page.label" src="{{page.whiteicon}}"></ion-icon>
            <p *ngIf="db.side_menu" class="p0 hover_title title mt0">{{page.label}}</p>
            <ion-icon class="forwd__icon" *ngIf="!db.ismobile && menu.active_menu == page.label && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
            <ion-icon class="updown_icon" *ngIf="!sub_category && page.sub_category  && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
            <ion-icon class="updown_icon" *ngIf="sub_category && page.sub_category  && db.side_menu" src="assets/icon/down-arrow.svg"></ion-icon>
            <!-- src="/assets/icon/up-arrow.svg" -->
          </div>
          <ion-list class="m-0 p0" for="state" *ngIf="db.side_menu" [class.trasition]="!sub_category">
            <ion-menu-toggle class="m_header mouse" *ngFor="let item of page.sub_category" (click)="open_subpage(item)" [class.active]="menu.active_sub == item.label" [class.m__header]="!db.side_menu">
              <p *ngIf="db.side_menu" class="p0 pl35 hover_title title mt0">{{item.label}}</p>
              <ion-icon class="forwd__icon" *ngIf="!db.ismobile && menu.active_sub == item.label && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
            </ion-menu-toggle>
          </ion-list>
        </ion-list>
        <ion-menu-toggle translate auto-hide="false" *ngIf="db.ismobile">
          <div (click)="db.logout()" class="p0 m_header mouse" [class.m__header]="!db.side_menu">
            <ion-icon slot="start" src="assets/collapes-menu/logout.svg"></ion-icon>
            <p *ngIf="db.side_menu"  class="p0 title hover_title logout">Logout</p>
          </div>
          <!--    <ion-item lines="none" (click)="logout()">
                        <ion-icon slot="start" src="/assets/Side-menu/log-out.svg"></ion-icon>
                        <div class="title">Logout</div>
                        </ion-item> -->
        </ion-menu-toggle>
        <!-- <ion-list class="side-menu" *ngIf="db.ismobile">
                    <ion-menu-toggle translate *ngFor="let page of menu.menu_items_list" auto-hide="false">
                        <div (click)="openPage(page)" [ngClass]="{'active': (menu.active_menu == page.label)}"
                            class="p0 m_header mouse" >
                            <ion-icon *ngIf="menu.active_menu != page.label " src="{{page.icon}}"></ion-icon>
                            <ion-icon *ngIf="menu.active_menu == page.label" src="{{page.whiteicon}}"></ion-icon>
                            <p class="p0 title">{{page.label}}</p>
                        </div>
                    </ion-menu-toggle>
                    <ion-menu-toggle translate auto-hide="false">
                        <div (click)="logout()" class="p0 m_header mouse">
                            <ion-icon slot="start" src="/assets/New-side-menu/Log-out.svg"></ion-icon>
                            <p class="p0 title">Logout</p>
                        </div>
                    </ion-menu-toggle>
                </ion-list> -->
      </ion-content>
      <ion-footer class="mouse" *ngIf="!db.ismobile">
        <ion-toolbar>
          <ion-item lines="none" (click)="db.side_menu = !db.side_menu">
            <ion-icon *ngIf="db.side_menu" src='assets/collapse-left.svg'></ion-icon>
            <ion-icon *ngIf="!db.side_menu" src='assets/collapse-right.svg'></ion-icon>
            <h6 *ngIf="db.side_menu" class="pl10">Collapse Sidebar</h6>
          </ion-item>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>
    <!-- [animation]="myCustomPageTransition" -->
    <ion-router-outlet id="main"></ion-router-outlet>
    <div *ngIf="db.ismobile && db.tabs" class="tab">
      <ion-tab-bar>
        <ion-tab-button *ngFor="let item of db.tabs_items" [tab]="item.tab" [routerLink]="item.route" routerDirection="root" routerLinkActive="active-item" [routerLinkActiveOptions]="{exact:true}">
          <ion-icon class="icon" [src]="item.icon"></ion-icon>
          <ion-label class="fnt-15">{{item.title}}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </div>
  </ion-split-pane>
  <ion-split-pane *ngIf="!menu.enable_pos_menu" contentId="main" class="posMenu 1233">
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>  

  <div *ngIf="add_animatings && add_animatings.length != 0" class="tostifyy success__alert">
    <div class="tostify d__flex " *ngFor="let item of add_animatings;let i =index" (click)="add_animatings.splice(i,1)">
        <div class="success-txt d__flex"> 
          <!-- {{item.images[0].product_image}}
          {{item.image}} -->
          <div class="image"><img src="{{db.product_img(item.images)}}"></div>
         <div class="text_grid">
           <span class="medium_name webkit-text" [style.--line]="3">{{item.item}}</span> 
           <span *ngIf="item.add_to_cart && item.add_to_cart == 1" class="sucss">Added to catalogue</span>
         </div>
        </div>
        <ion-icon name="close-outline"></ion-icon>
    </div>
  </div>

  <div  *ngIf="alert_animatings && alert_animatings.length != 0" class="alert tostifyy success__alert">
    <div  class="tostify d__flex" *ngFor="let item of alert_animatings;let i = index" (click)="alert_animatings.splice(i,1)">
      <div class="success-txt"> <span>{{item}}...</span> </div>
      <ion-icon name="close-outline"></ion-icon>
    </div>
  </div>

  <div  *ngIf="alert_list && alert_list.length != 0" class="alert_msg alert tostifyy success__alert" >
    <div [ngStyle]="{ 'color':item.text_color ? item.text_color : null,'background-color':item.bg_color ? item.bg_color : null }" class="tostify d__flex" *ngFor="let item of alert_list;let i = index" (click)="alert_list.splice(i,1)">
      <div class="success-txt"> <span>{{item.item}}</span> </div>
      <ion-icon name="close-outline"></ion-icon>
    </div>
  </div>
</ion-app>
